import { useEffect } from "react";
import TenantBar from "./TenantBar.jsx";
import NotificationBar from "./NotificationBar.jsx";
import LogoEchoSystem from "../ui/LogoEchoSystem.jsx";
import UserBar from "./UserBar.jsx";

const HeaderNavBar = ({
  openMenu,
  setOpenMenu,
  companiesList,
  branchesList,
  tenantUsername,
  tenant,
  tenantImage,
  companySelected,
  branchSelected,
}) => {
  useEffect(() => {
    const headerElement = document.querySelector(".primary-bg-color.sticky");
    if (!headerElement) return;
    const update = () => {
      document.documentElement.style.setProperty(
        "--header-height",
        `${headerElement.offsetHeight}px`,
      );
    };
    update();
    const observer = new ResizeObserver(update);
    observer.observe(headerElement);
    return () => observer.disconnect();
  }, []);
  return (
    <>
      <div className=" w-[100%]  flex justify-between items-center bg-[#251658]  sticky top-0 z-50 text-white  ">
        <div className="  px-2 ms-2 py-1  m-auto  w-full    flex justify-between items-center ">
          <div className="flex flex-col md:flex-row  w-full  justify-between items-center ">
            <div className="flex mt-1 items-center justify-between w-full ">
              {/* <MenuButton openMenu = {openMenu}  setOpenMenu = {setOpenMenu} /> */}
              <TenantBar
                companiesList={companiesList}
                branchesList={branchesList}
                companySelected={companySelected}
                branchSelected={branchSelected}
            
              />
            </div>
            <LogoEchoSystem name="مستودعات" />
            <UserBar
              tenantUsername={tenantUsername}
              tenantImage={tenantImage}
              tenant={tenant}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default HeaderNavBar;
